import React , {useState} from "react";
import { formServices } from "../../../services/formServices";

const StudentForm = () => {
    const [tostudent , setTostudent] = useState("");
    const [message , setMessage] = useState("");

    const handlePost = () => {
        return formServices.messagestudentPost(tostudent , message)
    }

    return (
        <div className="text-sm bg-white pt-4 px-5 pb-4  w-11/12 mx-auto rounded-md">
            <p className="text-xl font-bold gg-erp-color ">PARTICULAR STUDENT SMS</p>
            <div className="grid gap-2 md:grid-cols-2">   
                <label className="mb-2 w-full " for="to_student">To Student
                    <input type="search" name="to_student" className="form-input" onChange={e => setTostudent(e.target.value)}/>
                </label>
                <label for="message" className="mb-2 h-auto w-full ">Message
                    <textarea className="form-input h-20" placeholder="" type="text" name="message" onChange={e => setMessage(e.target.value)}/>
                </label>
            </div> 
            <hr/>
            <div className="text-right mt-2">
                <button type="submit" className="submit" onClick = {handlePost}>Send SMS</button>
            </div>
        </div>
    )
}

export default StudentForm